import { useSelector } from 'react-redux';
import { TextKey, RouteName } from '@mews-commander/enums';
import { ModalBodyWrapper, ModalWrapper } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { ApplicationState, WithOwnerId } from '@mews-commander/types';
import { useResolveRoute } from '@mews/routing';
import { getEnterpriseName } from '@mews-commander/legacy-entities/src/ducks/enterprises';
import ModalHeader from '../../legacy/React/Components/Common/ModalHeader';
import { Breadcrumbs } from '../../components/BreadcrumbList';
import { EmailSender } from './EmailSender';

export const EmailSenderContainer = ({ ownerId: enterpriseId }: WithOwnerId) => {
    const enterpriseName: string = useSelector((state: ApplicationState) => getEnterpriseName(state, { enterpriseId }));

    const resolveRoute = useResolveRoute();
    const enterpriseUrl = resolveRoute(RouteName.EnterpriseDetail, { enterpriseId });

    const breadcrumbs: Breadcrumbs = [
        { text: enterpriseName, url: enterpriseUrl },
        { text: <LocalizedText textKey={TextKey.SenderAddress} />, active: true },
    ];

    return (
        <ModalWrapper>
            <ModalHeader breadcrumbs={breadcrumbs} />
            <ModalBodyWrapper padded>
                <EmailSender enterpriseId={enterpriseId} />
            </ModalBodyWrapper>
        </ModalWrapper>
    );
};
